import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-shujutongji",
  "use": "icon-shujutongji-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-shujutongji\"><defs><style type=\"text/css\"></style></defs><path d=\"M864 128H160c-35.2 0-64 28.8-64 64v640c0 35.2 28.8 64 64 64h704c35.2 0 64-28.8 64-64V192c0-35.2-28.8-64-64-64zM320 768h-96V576h96v192z m160 0h-96V448h96v320z m160 0h-96V256h96v512z m161.2-1.3h-96v-384h96v384z\" p-id=\"4092\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol